<template>
    <!-- <card :title="title" :subTitle="subtitle" id="frame">  -->

    <card :title="title" :subTitle="subtitle" id="frame">
        <div class="alert alert-success" v-if="showAlarm">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
            <span>
                <b>{{ alarm }}</b>
            </span>
        </div>
        <div class="alert alert-danger" v-if="tempAlert" id="MessWarning">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableTempNotification">×</button>
            <span class="messstellenWarnung">
                <b>
                    <h3>
                        <v-icon left large>warning</v-icon>
                        Folgende Messstellen wurden nicht überprüft:<br />
                    </h3>

                    <div v-if="missingBereiche1">Bereich 1: {{ missingBereiche1 }}<br /></div>
                    <div v-if="missingBereiche2">Bereich 2: {{ missingBereiche2 }}<br /></div>
                    <div v-if="missingBereiche3">Bereich 3: {{ missingBereiche3 }}<br /></div>
                    <div v-if="missingBereiche4">Bereich 4: {{ missingBereiche4 }}<br /></div>
                </b>
            </span>
        </div>
        <v-text-field v-model="search" label="Search" required clearable>
            <template slot="append">
                <v-icon>search</v-icon>
                <v-icon @click="fetchCustomer">refresh</v-icon>
            </template>
        </v-text-field>
        <br />
        <v-data-table :headers="headers" :items="kunden" :search="search" class="elevation-1" :pagination.sync="pagination">
            <template v-slot:items="props">
                <td v-if="props.item.Nachname || props.item.Firma !== '-'">
                    <v-icon small @click="addTermin(props.item)" v-if="props.item.Status === 'aktiv' && props.item.Firma !== 'Blocker'"> calendar_today </v-icon>
                    <v-icon small v-if="props.item.Status === 'inaktiv'" color="red"> https </v-icon>
                </td>

                <td v-if="props.item.Nachname || props.item.Firma !== '-'" class="text-xs-left">{{ props.item.Nachname }}</td>
                <td v-if="props.item.Nachname || props.item.Firma !== '-'" class="text-xs-left">{{ props.item.Firma }}</td>
                <td v-if="props.item.Nachname || props.item.Firma !== '-'">{{ props.item.Bezirk }}</td>
                <td v-if="props.item.Nachname || props.item.Firma !== '-'" class="text-xs-left">{{ props.item.Strasse }}</td>
                <td v-if="props.item.Nachname || props.item.Firma !== '-'" class="text-xs-left">{{ props.item.Hausnummer }}</td>
                <td v-if="props.item.Nachname || props.item.Firma !== '-'">{{ props.item.Kunden_Nr }}</td>
            </template>
            <template v-slot:no-data>
                <v-alert :value="true" color="error" icon="warning"> Keine Kunden gefunden! </v-alert>
            </template>
        </v-data-table>
    </card>
    <!-- </card> -->
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
                missingBereiche1: "",
                missingBereiche2: "",
                missingBereiche3: "",
                missingBereiche4: "",
                tempAlert: false,
                pagination: {},
                kunden: [],
                search: "",
                title: "Termine erstellen",
                subtitle: "",
                headers: [
                    { text: "", value: "name", sortable: false },

                    {
                        text: "Name",
                        align: "left",
                        sortable: false,
                        value: "Nachname"
                    },
                    {
                        text: "Firma",
                        align: "left",
                        sortable: false,
                        value: "Firma"
                    },
                    {
                        text: "Bez.",
                        align: "left",
                        sortable: false,
                        value: "Bezirk"
                    },
                    {
                        text: "Strasse",
                        align: "left",
                        sortable: false,
                        value: "Strasse"
                    },
                    {
                        text: "Nr.",
                        align: "left",
                        sortable: false,
                        value: "Hausnummer"
                    },

                    {
                        text: "Knr.",
                        align: "left",
                        sortable: false,
                        value: "Kunden_Nr"
                    }
                ],
                alarm: "",
                showAlarm: false
            }
        },
        methods: {
            fetchMissingMessstellen() {
                this.$http.get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/tempLogs/check", { headers: { Authorization: this.auth } }).then(function (response) {
                    if (response.body.missingBereiche1 || response.body.missingBereiche2 || response.body.missingBereiche3) {
                        this.missingBereiche1 = response.body.missingBereiche1
                        this.missingBereiche2 = response.body.missingBereiche2
                        this.missingBereiche3 = response.body.missingBereiche3
                        this.missingBereiche4 = response.body.missingBereiche4
                        this.tempAlert = true
                    }
                })
            },
            disableTempNotification() {
                if (confirm("Wurde eine Überprüfung veranlasst?")) {
                    this.tempAlert = false
                }
            },
            fetchCustomer() {
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/kunden", { auth: process.env.VUE_APP_PHP_AUTH }).then(function (response) {
                    // console.log(response.body);
                    this.kunden = response.body
                    this.pagination.totalItems = response.body.length
                    this.pagination.rowsPerPage = 20
                    this.subtitle = response.body.length + " Kunden "
                })
            },
            disableNotification() {
                this.showAlarm = !this.showAlarm
            },
            addTermin(kunde) {
                this.$router.push({ path: "/addbestellung/" + kunde.Kunden_Nr })
                // console.log(kunde);
            }
        },

        created: function () {
            this.fetchCustomer()
            if (this.$route.query.alarm) {
                this.alarm = this.$route.query.alarm
                this.showAlarm = true
            }
            var actualHour = new Date().getHours()
            if (14 < actualHour) {
                this.fetchMissingMessstellen()
            }
        },
        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        }
        // updated: function(){
        // }
    }
</script>

<style scoped>
    .messstellenWarnung {
        color: white;
    }
    #MessWarning {
        background-color: rgb(209, 32, 8);
    }
    #buttons {
        padding-top: 5%;
        padding-bottom: 0%;
    }
    .vcard {
        border-radius: 10px 10px 10px 10px;
    }
    .alert {
        border-radius: 7px 7px 7px 7px;
        text-align: center;
    }
</style>
